<template lang="pug">
v-layout.px-3(column)
  v-subheader.pl-4.mt-3.pb-3 Поиск заявки
  v-layout(row :class="{ 'px-4' : !$vuetify.breakpoint.xsOnly}")
    v-card(width="100%")
      v-card-text
        v-container.py-2(fluid grid-list-xl :class="[ $vuetify.breakpoint.xsAndDown ? 'px-0' : 'px-3']")
          v-layout(row wrap)
            v-flex(xs12 sm4)
              v-autocomplete(:label="$tf('drawer.process.type')" v-model="processDefinitionKey" :items="allDefinitions" item-text="name" item-value="key" item-disabled="disabled" clearable :placeholder="$tf('drawer.process.all')")
            v-flex(xs12 sm4)
              v-text-field(:label="$tf('drawer.process.number')" v-model="businessKey" clearable placeholder="AAA-BB-CCCCCCCC-DDDDDD")
            v-flex(xs12 sm4)
              wf-date-picker(:label="$tf('drawer.process.fromDate')" v-model="startDate" :max="maxStartDate")
            v-flex(xs12 sm4)
              wf-date-picker(:label="$tf('drawer.process.toDate')" v-model="endDate" :max="maxStartDate")
            v-flex(xs12 sm4)
              v-select(:label="$tf('drawer.process.role')" v-model="role" :items="roleList" item-text="text" item-value="value")
            v-flex(xs12 sm4 v-if="hasOtherGroup && role == 'other'")
              v-text-field(:label="$tf('drawer.process.initiator')" v-model="initiator" clearable :placeholder="$tf('drawer.process.IIN')")
            v-flex(xs12 sm4 v-if="hasOtherGroup && role == 'other'")
              v-text-field(:label="$tf('drawer.process.initiator')" v-model="fio" clearable :placeholder="$tf('drawer.process.fio')")
            v-flex(xs12 sm4)
              v-select(:label="$tf('drawer.process.status')" v-model="status" :items="statusList" item-text="text" item-value="value" clearable :placeholder="$tf('drawer.process.all')")
            v-flex(xs12 sm4)
              v-select(:label="$tf('drawer.process.urgent')" v-model="urgent" :items="urgentList" item-text="text" item-value="value" clearable :placeholder="$tf('drawer.process.all')")
            v-flex.px-5(xs12)
              v-btn(color="primary" block @click="search") {{ $tf("drawer.process.search") }}

        v-divider.ma-2

        div(v-if="total > 0")
          v-list.overflow-x-hidden(four-line)
            v-subheader {{ $tf("drawer.process.searchResult") }} ({{ total }})
            template(v-for="(process, index) in processes")
              v-list-tile(:key="process.id" avatar ripple)
                v-list-tile-avatar(@click="selectProcess(process.id, index)" v-if="!$vuetify.breakpoint.xsOnly")
                  i.v-icon.white--text.material-icons.process-default-icon(:class="process.processDefinitionKey")
                v-list-tile-content(@click="selectProcess(process.id, index)")
                  v-list-tile-title(v-html="getTitle(process)")
                  v-list-tile-sub-title {{ process.fio }}
                  v-list-tile-sub-title {{ process.state == 'ACTIVE' ? $tf("process.status.active")  + ' (' + (process.status == 'postponed' ? $tf("forms.postponed") : $tf("forms.inProgress")) + ')' : process.state == 'COMPLETED' ? $tf("process.status.completed") + ' (' + (process.status == 'completed' ? $tf("forms.completed") : (process.status == 'postponed' ? $tf("forms.postponed") : (process.status == 'declined' ? $tf("forms.declined") : $tf("forms.done")))) + ')'  : $tf("process.status.terminated") }}
                  v-progress-linear.v-list-loading-indicator(:active="loading['_' + index]" :indeterminate="true" height="2")
                v-list-tile-action(style="white-space: normal")
                  v-list-tile-action-text(v-html="getRange(process)")
                  v-btn(color="primary" block @click="cancel(process)" v-if="process.startUserId === profile.userName && !process.endTime && ['BMA-01','BMA-02'].indexOf(process.processDefinitionKey) !== -1 && !process.buhApproveResult && !process.srpResult") {{ $tf("fileUploader.cancel") }}
              v-divider(inset)
          .text-xs-center.my-1
            v-pagination(v-model="page.current" :length="length" :total-visible="6" v-if="total > page.per && processes")

        div(v-if="total == 0")
          v-flex(xs12)
            div.nothing-right-div
              v-layout(align-center justify-center row fill-height)
                div.headline.grey--text.ta-c.px-5 {{ $tf("drawer.process.searchNotFound") }}

    wf-process-info(ref="processInfo")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProcessInfo from '@/components/process/ProcessInfo'
import lodash from 'lodash'
import camundaAPI from '@/services/camunda'

export default {
  name: 'ProcessSeach',

  components: {
    'wf-process-info': ProcessInfo, 
  },

  data() {
    return {
      processDefinitionKey: null,
      businessKey: null,
      startDate: this.$moment(new Date()).subtract(30, 'days').toDate(),
      maxStartDate: this.$moment().toDate(),
      role: 'initiator',
      status: null,
      initiator: null,
      endDate: this.$moment(new Date()).add(1, 'days').toDate(),
      urgent: null,
      fio: null,

      roleList: [
        { value: 'initiator', text: this.$tf('drawer.process.iaminitiator'), disabled: false }
      ],

      statusList: [
        { value: 'finished', text: this.$tf('drawer.process.endedProcesses') },
        { value: 'unfinished', text: this.$tf('drawer.process.inProgressProcesses') },
      ],

      urgentList: [
        { value: 'urgent', text: this.$tf('drawer.process.urgently') },
        { value: 'notUrgent', text: this.$tf('drawer.process.notUrgently') },
      ],

      loading: {
        _0: false,
        _1: false,
        _2: false,
        _3: false,
        _4: false,
        _5: false,
        _6: false,
        _7: false,
        _8: false,
        _9: false,
      },
    }
  },

  computed: {
    ...mapGetters({
      allDefinitions: 'process/allDefinitions',
      processes: 'process/processes',
      total: 'process/total',
      page: 'process/page',
      processInfoDialog: 'process/processInfoDialog',
      profile: 'auth/profile',
      groups: 'auth/groups',
    }),
    length() {
      return Math.ceil((this.total / this.page.per))
    },
    hasOtherGroup() {
      const result = lodash.some(this.groups, (group) => group.id !== 'allUsers')
      if(result){
        this.roleList = [
          { value: 'initiator', text: this.$tf('drawer.process.iaminitiator'), disabled: false },
          { value: 'participant', text: this.$tf('drawer.process.iconfirmed'), disabled: false },
          { value: 'other', text: this.$tf('drawer.process.otherinitiator'), disabled: false },
        ];
      }
      return result
    },
  },

  watch: {
    'page.current'(newValue) {
      this.paginateProcesses({ newPageNumber: newValue, searchCriteria: this.getPayload(), reset: false })
    },
  },

  created() {
    this.getDefinitions()
    this._search({ searchCriteria: this.getPayload(), reset: true })
  },

  methods: {
    ...mapActions({
      getDefinitions: 'process/getDefinitions',
      _search: 'process/search',
      paginateProcesses: 'process/paginateProcesses',
      toggleProcessInfoDialog: 'process/toggleProcessInfoDialog',
    }),

    showConfirm(payload){
      return this.$store.dispatch('tools/showConfirm', payload)
    },

    getTitle(processes) {
      const titleBusinessKey = processes.businessKey ? `- ${processes.businessKey}` : ''
      return `${processes.processDefinitionName} ${titleBusinessKey}`
    },

    getRange(process) {
      return `${this.$moment(process.startTime).format('DD.MM.YYYY HH:mm')} - ${process.endTime ? `${this.$moment(process.endTime).format('DD.MM.YYYY HH:mm')}` : '___.___._____ __:__'}`
    },

    getPayload() {
      let payload = {
        startedAfter: this.$moment(this.startDate)
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .format('YYYY-MM-DDTHH:mm:ss.SSSZZ'),
        startedBefore: this.$moment(this.endDate)
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .format('YYYY-MM-DDTHH:mm:ss.SSSZZ'),
        finished: this.status === 'finished',
        unfinished: this.status === 'unfinished',
        processDefinitionKeyNotIn: ['NEWS-01','USER-01','USER-02','USER-03','NOTIFY-01'],
        variables: [] }
      if (this.processDefinitionKey) {
        payload = { ...payload, processDefinitionKey: this.processDefinitionKey }
      }      
      if (this.businessKey) {
        payload = { ...payload, processInstanceBusinessKeyLike: '%'+this.businessKey }
      }
      if (this.role === 'other') {
        if (this.initiator) {
          payload.variables.push({
            name: 'iin',
            operator: 'eq',
            value: this.initiator
          });
        }
        if (this.fio) {
          payload.variables.push({
            name: 'fio',
            operator: 'like',
            value: '%' + this.fio + '%'
          });
        }       
      } else if (this.role === 'participant') {
        delete payload.startedBy
        let taskPayload = {
          taskAssignee: this.profile.userName,
          assigned: true,
          startedAfter: this.$moment(this.startDate)
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .format('YYYY-MM-DDTHH:mm:ss.SSSZZ'),
          startedBefore: this.$moment(this.endDate)
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .format('YYYY-MM-DDTHH:mm:ss.SSSZZ') }

        if (this.processDefinitionKey) {
          taskPayload = { ...taskPayload, processDefinitionKey: this.processDefinitionKey }
        }
        payload = { ...payload, taskPayload: taskPayload }
      } else {
        payload.variables.push({
          name: 'iin',
          operator: 'eq',
          value: this.profile.userName
        });
      }
      payload = { ...payload, searchVariables: ['fio', 'status', 'buhApproveResult', 'srpResult']}
      if(this.urgent){
        if(payload.variables){
          payload.variables.push({
            name: 'urgent',
            operator: 'eq',
            value: this.urgent === 'urgent'
          });
        }
      }
      return payload
    },

    search() {
      this._search({ searchCriteria: this.getPayload(), reset: true })
    },

    selectProcess(processId) {
      this.$refs.processInfo.show(processId)
    },

    cancel(process) {
      console.log(process);
      this.showConfirm({
        title: this.$tf('process.confirm.cancel'),
        persistent: true,
        resolveText: this.$tf('task.confirm.yes'),
        rejectText: this.$tf('task.confirm.no') })
        .then(() => {
          camundaAPI.process.cancel(process.id).then((response) => {
            this.search()
          });
        }).catch(() => {
        })
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.processInfoDialog) {
      this.toggleProcessInfoDialog(false)
      next(false)
    } else {
      next(true)
    }
  },
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/process/ProcessSearch.vue